<div id="no-phenology-device-container" class="row">
  <div class="col-12">
    <div class="box">
      <div class="add-container">
        <p class="title">{{ 'doktar_app.services.pest_management.add_device_title' | translate }}</p>
        <p class="description">{{ 'doktar_app.account.devices.add_device_button_description' | translate }}</p>
        <div class="col-auto">
          <dk-button
            label="Add a phenology camera now"
            (onClick)="openAddDeviceModal()">
            @if (loading) {
              <i class="pi pi-spin pi-spinner-dotted"></i>
            }
          </dk-button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 mt-4">
    <div class="box">
      <div class="more-info">
        <div class="content title">{{ 'doktar_app.common.devices.want_more_title' | translate }}</div>
        <div class="content description mt-2">
          {{ 'doktar_app.common.pest_management.want_more_description' | translate }}
        </div>
        <div class="d-flex justify-content-start mt-3">
          <dk-button
            id="add-btn"
            label="{{ 'doktar_app.communications.home.request_callback' | translate }}"
            severity="secondary"
            (onClick)="openRequestCallModal()" />

          <dk-account-request-callback #requestCallback />
        </div>
      </div>
    </div>
  </div>
</div>
